/** Move a node behind the previous designer object in its parent container. */
export function moveObjectBackward(node, isDesignerObject) {
  const parent = node.getParent?.();
  if (!parent) return false;

  const siblings = parent.getChildren();
  const previousIndex = siblings
    .slice(0, node.zIndex())
    .map((sibling, index) => isDesignerObject(sibling) ? index : -1)
    .filter(index => index !== -1)
    .pop();
  if (previousIndex === undefined) return false;

  // Setting the previous object's index places this node directly behind it,
  // skipping page internals such as the background rect and id label.
  node.zIndex(previousIndex);
  node.getLayer?.()?.batchDraw?.();
  return true;
}
